
export function initImage()
{
	return {layout:'image',upload:{},display:{parent:true}};
}

/*
	LayoutComponents: cf making conversions smarter - eg...
	   If single Slides etc ==> Ask user: unwap?
	   If Image, Vertical, ..., Styles => Slides  maybe ask user - wrap?
			NOTE you can put anything in Styles, so restrictions aren't that meaningful
	   If content exists ==> show warning.

	NB version control and/or undo for layout components would also be useful.
*/

/* Reuse old children wherever we can */
export function fieldsToKeep(old?:any)
{
	if (!old)
		return {items:undefined,content:undefined};

	const items = old.items ?? old.slides ?? (old.content ? [old.content] : undefined);
	const content = old.content ?? (old.items ? old.items[0] : undefined) ?? (old.slides ? old.slides[0] : undefined) ?? initImage();
//XXX cf including 'background' and/or 'upper'? Less clear these are the best choices...

	return {items,content};
}
